import useRenewAccessToken from '@/core/hooks/auth/useRenewAccessToken/useRenewAccessToken';

export default useRenewAccessToken;
